var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIdentifyValue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 10C8.34314 10 7 9.01503 7 7.8C7 6.58497 8.34314 5.6 9.99999 5.6M9.99999 10C11.6568 10 13 10.985 13 12.2C13 13.415 11.6569 14.4 10 14.4M9.99999 10V5.6M9.99999 10L10 14.4M9.99999 5.6C11.1104 5.6 12.0799 6.04242 12.5986 6.7M9.99999 5.6V4.5M10 14.4L9.99999 15.5M10 14.4C8.8896 14.4 7.92008 13.9576 7.40137 13.3M21 21L16.364 16.364M16.364 16.364C14.7353 17.9926 12.4853 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 12.4853 17.9926 14.7353 16.364 16.364Z",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIdentifyValue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/identify-value.cce8fe9a.svg";
export { ForwardRef as ReactComponent };